import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import ConfirmForm from './ConfirmForm';
import { injectIntl } from 'react-intl';

class ProfileForm extends ConfirmForm {


    componentDidMount() {
        if (typeof window !== "undefined") {
            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit, intl, dispatch, accounting, taxes, hasMultipleLocations, locations, profile, themes, currentInvoiceDate } = this.props;
        const t = (id) => intl.formatMessage({ id });

        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let isFreePlan = profile.profile && profile.profile.subscription === 'free';

        return (<div className="container-fluid">
            <style>{`

            textarea{
                font-size:10px;
                font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New;
                background-color: beige;
                border: none;
            }

            `}</style>
            <div className="row">
                <h3>{t('autopilot.title')}</h3>
                <form className="col-md-4" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">

                        <label htmlFor="autoInvoicingMode">{t('autopilot.autoCreate')}</label>



                        <Field disabled={isFreePlan} className="form-control" name="autoInvoicingMode" component="select">
                            <option value="manual">{t('autopilot.disabled')}</option>
                            <option title={t('autopilot.whenCreated')} value="orders/create">{t('autopilot.whenCreated')}</option>
                            <option value="orders/fulfilled" title={t('autopilot.whenFulfilled')}>{t('autopilot.whenFulfilled')}</option>
                            <option value="orders/paid" title={t('autopilot.whenPaid')}>{t('autopilot.whenPaid')}</option>
                        </Field>
                        <p><small className="text-small">{t('autopilot.autoCreateDesc')}</small></p>

                        <label htmlFor="autoStornoMode">{t('autopilot.autoStorno')}</label>

                        <Field disabled={isFreePlan} className="form-control" name="autoStornoMode" component="select">
                            <option value="manual">{t('autopilot.disabled')}</option>
                            <option title={t('autopilot.whenCancelled')} value="cancel">{t('autopilot.whenCancelled')}</option>
                        </Field>
                        <p><small className="text-small">{t('autopilot.autoStornoDesc')}</small></p>
                    </div>
                    {isFreePlan && <div>
                                <div className="panel panel-danger">
                                    <h4>{t('autopilot.cannotAutoFree')}</h4>
                                    <button className="btn btn-success" onClick={() => { window ? window.location.href = 'billing' : () => { } }}>{t('autopilot.upgradePlan')}</button>
                                </div>
                            </div>
                        }
                    <br />
                    <div className={pristine ? "save-panel" : "save-panel visible"}>{t('autopilot.unsavedChanges')}</div>
                        {!pristine && <button type="button" onClick={() => location.reload()} className="discard-changes-button btn btn-default btn-sm">{t('autopilot.discard')}</button>}
                    <button id="save-changes" style={{
                        position: 'fixed',
                        top: '10px',
                        right: '10px',
                        zIndex: '99999999',
                        opacity: pristine ? 0 : 1
                    }} className="btn btn-success btn-sm" type="submit" disabled={pristine || submitting || initialValues.reverting} ><i className="fa fa-check"></i>&nbsp;{t('autopilot.save')}</button>
                    <i style={{
                        position: 'fixed',
                        top: '20px',
                        left: '13px',
                        zIndex: '99999997',
                        fontSize: '23px',
                        color: 'white'

                    }} onClick={() => {
                        window.location.href = '/' + this.props.intl.locale + '/dashboard';
                    }
                    } className="back-button fa fa-arrow-circle-left">&nbsp;</i>

                </form>


            </div>


        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{intl.formatMessage({ id: 'autopilot.title' })}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/Autopilot.jsx